import axios, { AxiosRequestConfig, AxiosError } from 'axios';
import { JsonError } from "../constants/JsonError";

export const processFetch = async <T>(args: AxiosRequestConfig, jwt?: string | null): Promise<T> => {
    const authHeader = jwt ? { 'Authorization': `Bearer ${jwt}` } : {};
    const headers = { ...args.headers, ...authHeader };
    const options = { ...args, headers };

    try {
        const response = await axios.request<T>(options);
        return new Promise((resolve, reject) => {
            if (response.status >= 200 && response.status < 300) {
                resolve(response.data);
            }
            else {
                const contentType = typeof response.headers.get === 'function' ? response.headers.get("content-type") : undefined;
                if (typeof contentType === 'string' && contentType.indexOf("application/json") !== -1) {
                    reject(new JsonError(response.data as Record<string, unknown>));
                }
                else {
                    reject(new Error(response.statusText));
                }
            }
        })
    }
    catch (err) {
        return new Promise((resolve, reject) => {
            const axiosErr = err as AxiosError<Record<string, unknown>> | undefined;
            const contentType = axiosErr?.response?.headers?.["content-type"] as string | undefined;
            if (contentType && contentType.indexOf("application/json") !== -1 && axiosErr?.response) {
                reject(new JsonError(axiosErr.response.data as Record<string, unknown>));
            }
            else {
                const text = axiosErr?.response?.statusText || axiosErr?.message || String(err);
                const url = axiosErr?.config?.url || '';
                reject(new Error(text + ' at ' + url));
            }
        })
    }
};

export const getJson = <T>(args: AxiosRequestConfig, jwt?: string | null) => 
    processFetch<T>(args, jwt);

export const postJson = <T>(args: AxiosRequestConfig, jwt?: string | null) => 
    processFetch<T>(
    {
        ...args,
        url: args.url,
        method: 'POST',
        headers: {
            ...args.headers,
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
    }, jwt);

export const putJson = <T>(args: AxiosRequestConfig, jwt?: string | null) =>
    processFetch<T>(
    {
        ...args,
        url: args.url,
        method: 'PUT',
        headers: {
            ...args.headers,
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
    }, jwt);

export const del = <T>(args: AxiosRequestConfig, jwt?: string | null) =>
    processFetch<T>(
    {
        ...args,
        url: args.url,
        method: 'DELETE',
    }, jwt);
